import { createReducerTypeSafe } from '@/utils/redux';

import { StoreInitActionPayload, storeInitialized, storeLogout } from './actions';
import { initialState, State } from './types';

export const reducers = createReducerTypeSafe<State>(initialState, [
  [
    storeInitialized,
    (state: State, { banks }: StoreInitActionPayload): State => ({
      initialized: true,
      banks,
    }),
  ],
  [storeLogout, (): State => ({ ...initialState, initialized: true })],
]);

export default reducers;
